
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { SocialSignUpButtons } from "./auth/SocialSignUpButtons";
import { EmailSignUpForm } from "./auth/EmailSignUpForm";

interface SignUpDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const SignUpDialog = ({ open, onOpenChange }: SignUpDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Create your account</DialogTitle>
          <DialogDescription>
            Get started with ComplianceBloom today. No credit card required.
          </DialogDescription>
        </DialogHeader>

        <SocialSignUpButtons onSuccess={() => onOpenChange(false)} />
        <EmailSignUpForm onSuccess={() => onOpenChange(false)} />
      </DialogContent>
    </Dialog>
  );
};
